import React from "react";

interface ColumnProps {
  children: React.ReactNode;
  gap?: number;
  marginTop?: number;
  border?: boolean;
  itemPosition?: "center" | "start" | "end";
  width?: "full" | "auto";
  paddingTop?: number;
  className?: string;
}
const Column = ({
  children,
  gap = 0,
  marginTop,
  border,
  width = "full",
  itemPosition,
  paddingTop,
  className,
}: ColumnProps) => {
  const gapStyle = gap ? { gap: `${gap * 0.25}rem` } : {};
  const paddingTopStyle = paddingTop ? { paddingTop: `${paddingTop}rem` } : {};
  return (
    <div
      className={`flex flex-col mt-${marginTop} w-${width}  items-${itemPosition} ${className}`}
      style={{ ...gapStyle, ...paddingTopStyle }}
    >
      {children}
    </div>
  );
};

export default Column;
